// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".range-group[data-v-f98d5f98]{align-items:center;display:flex;flex-flow:row nowrap;justify-content:space-between;margin-bottom:2rem}.range-group .divider[data-v-f98d5f98]{background-color:#ddd;flex:1 1 40%;height:1px;margin:0 .5rem}.range-group .form-control[data-v-f98d5f98]{border-radius:2px;flex:0 0 42%;font-size:1.2rem;max-width:42%;min-height:2rem}.price-range-submit[data-v-f98d5f98]{font-size:1.4rem;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
